import {
  
  GET_TEST_DEFINITIONS_SUCCESS,
  ADD_TEST_DEFINITION_SUCCESS,
  UPDATE_TEST_DEFINITION_SUCCESS,
  DELETE_TEST_DEFINITION_SUCCESS,
  TEST_DEFINITION_API_ERROR

} from "./actionTypes"

const INIT_STATE = {
  testDefinitions: [],
  error: {},
}

const TestDefinition = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_TEST_DEFINITIONS_SUCCESS:
      return {
        ...state,
        testDefinitions: action.payload,
      }

    case ADD_TEST_DEFINITION_SUCCESS:
      return {
        ...state,
        testDefinitions: [...state.testDefinitions, action.payload],
      }

    case UPDATE_TEST_DEFINITION_SUCCESS:
      return {
        ...state,
        testDefinitions: state.testDefinitions.map(testDefinition =>
          testDefinition.guid.toString() === action.payload.guid.toString()
            ? { testDefinition, ...action.payload }
            : testDefinition
        ),
      }

    case DELETE_TEST_DEFINITION_SUCCESS:
      return {
        ...state,
        testDefinitions: state.testDefinitions.filter(
          testDefinition => testDefinition.guid.toString() !== action.payload.guid.toString()
        ),
      }

    case TEST_DEFINITION_API_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    default:

      return state

  }
}

export default TestDefinition